import React from 'react'
import ContactUs from '../components/ContactUs/ContactUs'
import DynamicBanner from '../components/DynamicBanner/DynamicBanner'

const ContactPage = () => {
  return (
    <div>
      <DynamicBanner />
      <ContactUs/>
    </div>
  )
}

export default ContactPage